import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import { useFiltersStore } from '@/stores/useFiltersStore';
import { useGlobalConfigurationStore } from '@/stores/useGlobalConfigurationStore';
import { useProductsStore } from '@/stores/useProductsStore';

export default function useRouting() {
  const globalConfigurationStore = useGlobalConfigurationStore();
  const { routingOptions } = storeToRefs(globalConfigurationStore);

  const defaultRoute = computed(() => routingOptions.value?.find(it => it.taxonomies?.length === 0));

  async function redirectOrFetch() {
    const productsStore = useProductsStore();
    const filtersStore = useFiltersStore();
    const { filters } = storeToRefs(filtersStore);
    const selectedThemes = filters.value.selections.find((it: any) => it.filterProperties.type === 'taxonomyThemes')?.selection ?? [];
    const selectedTypes = filters.value.selections.find((it: any) => it.filterProperties.type === 'taxonomyTypes')?.selection ?? [];
    const routingConditions: any = [];
    if (selectedThemes.length > 0)
      routingConditions.push({ type: 'THEMES', value: selectedThemes });
    if (selectedTypes.length > 0)
      routingConditions.push({ type: 'TYPES', value: selectedTypes });

    const specificRoute = routingOptions.value?.find(route =>
      JSON.stringify(route.taxonomies) === JSON.stringify(routingConditions) || JSON.stringify(route.taxonomies) === JSON.stringify(routingConditions.reverse()),
    );

    if (specificRoute && specificRoute.url !== window.location.href) {
      window.location.href = specificRoute.url;
    }
    else if (!specificRoute && defaultRoute.value && window.location.href !== defaultRoute.value.url) {
      window.location.href = defaultRoute.value.url;
    }
    else {
      productsStore.fetchProductsList(filters.value)
        .catch((err: unknown) => console.error(err));
    }
  }

  return {
    defaultRoute,
    redirectOrFetch,
  };
}
